export const UPLOAD_REFUND_KYC_DOCUMENT_FAILURE =
  'UPLOAD_REFUND_KYC_DOCUMENT_FAILURE';
